import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "stale-bar"
}
const _hoisted_2 = {
  key: 1,
  class: "filter-bar"
}
const _hoisted_3 = { class: "filter-bar-inner" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "flt-chevron",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_6 = {
  key: 0,
  class: "flt-panel"
}
const _hoisted_7 = { class: "flt-panel-head" }
const _hoisted_8 = { class: "flt-head-count" }
const _hoisted_9 = { class: "flt-panel-list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_12 = { class: "flt-item-name" }
const _hoisted_13 = { class: "flt-item-count" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "flt-panel"
}
const _hoisted_16 = { class: "flt-panel-head" }
const _hoisted_17 = { class: "flt-head-count" }
const _hoisted_18 = { class: "flt-panel-list" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_21 = { class: "flt-item-name" }
const _hoisted_22 = { class: "flt-item-count" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "flt-panel"
}
const _hoisted_25 = { class: "flt-panel-head" }
const _hoisted_26 = { class: "flt-head-count" }
const _hoisted_27 = { class: "flt-panel-list" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_30 = { class: "flt-item-name" }
const _hoisted_31 = { class: "flt-item-count" }
const _hoisted_32 = {
  class: "tol-control",
  title: "Tempo mínimo de espera para exibir na aba Aguardando e gerar alerta"
}
const _hoisted_33 = {
  key: 0,
  class: "filter-chips-bar"
}
const _hoisted_34 = { class: "filter-chips-bar-inner" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  class: "filter-active-info"
}
const _hoisted_39 = { class: "filter-active-badge" }
const _hoisted_40 = { class: "cols" }
const _hoisted_41 = { class: "notif-card-body" }
const _hoisted_42 = { class: "notif-card-title" }
const _hoisted_43 = { class: "notif-card-wait" }
const _hoisted_44 = { class: "notif-card-meta" }
const _hoisted_45 = {
  key: 0,
  class: "notif-meta-tag"
}
const _hoisted_46 = { class: "notif-card-actions" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]

import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useStore } from 'vuex'
import { usePermission } from '@/composables/usePermission'
import { syncUserRole, useAdmin, resolveRoleScope } from '@/composables/useAdmin'
import type { Conversation, PopupData } from '@/types/dashboard'
import { testNotification } from '@/services/notifications'
import { fluxoLabel } from '@/composables/useHelpers'
import { isFluxoHidden } from '@/composables/useHiddenFluxos'
import { requestOpenChat, setConvNavList } from '@/composables/useChatTrigger'
import { useFloatChats } from '@/composables/useFloatChats'

import LoadingOverlay      from '@/components/dashboard/LoadingOverlay.vue'
import {
  headerLoading, headerLastUpdate, headerMyCount, headerMyOpenCount, headerMyTeamFilter, registerHeaderCallbacks,
} from '@/composables/useHeaderState'
import KpiGrid             from '@/components/dashboard/KpiGrid.vue'
import MultiSelectFilter   from '@/components/dashboard/MultiSelectFilter.vue'
import TabsPanel           from '@/components/dashboard/TabsPanel.vue'
import SidePanel           from '@/components/dashboard/SidePanel.vue'
import ConversationsPanel  from '@/components/dashboard/ConversationsPanel.vue'
import AvatarPopup         from '@/components/dashboard/AvatarPopup.vue'
import AgentSummaryModal   from '@/components/dashboard/AgentSummaryModal.vue'
import ContactHistoryModal from '@/components/dashboard/ContactHistoryModal.vue'
import { useConversationStore } from '@/composables/useConversationStore'
// Motor de dados do Dashboard (polling, badge "Mês", notificações) — vive fora
// do ciclo de vida desta view (ver useDashboardEngine.ts) pra continuar
// rodando mesmo quando o usuário sai desta tela; iniciado uma vez em App.vue.
import {
  allAgents, allTeamsWithMembers, dataStale, changedIds, visaoGeralPeriodo, toleranceMinutes,
  toastMessage, toastVisible, toastError, activeNotifications, scopeReady,
  toast, clampTolerance, dismissNotif, roleFilteredConversations, monthOnlyCount, passesFluxoFilter,
  setVisaoGeralPeriodo, loadData, startDashboardEngine,
} from '@/composables/useDashboardEngine'

const CHATWOOT_ACCOUNT_ID = 3


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const store  = useStore()

const authUser    = computed(() => store.getters.authUser)
const isAdmin     = computed(() => store.getters.isAdmin)
const userTeamIds = computed<number[]>(() => store.getters.userTeamIds)

const { can } = usePermission()
const { hasPermission } = useAdmin()
const { open: openFloatChat } = useFloatChats()

/* ── State ─────────────────────────────────── */
const { conversations } = useConversationStore()
const selectedTeams      = ref<number[]>([])
const filterOpen         = ref(false)
const filterDropdownRef  = ref<HTMLElement | null>(null)
const selectedLabels     = ref<string[]>([])
const labelFilterOpen    = ref(false)
const labelFilterDropdownRef = ref<HTMLElement | null>(null)
const selectedFluxos     = ref<number[]>([])
const fluxoFilterOpen    = ref(false)
const fluxoFilterDropdownRef = ref<HTMLElement | null>(null)
// Fase 1 do plano de filtro de status (docs/planos/PLANO-FILTRO-STATUS-VISAO-GERAL.md):
// default só "Aberta" — ainda client-side, a busca de rede continua trazendo tudo.
// id/name no formato esperado por MultiSelectFilter.vue (mesmo componente genérico
// usado em "Esconder Fluxo", DashHeader.vue).
const STATUS_FILTER_OPTIONS: { id: string; name: string }[] = [
  { id: 'open',     name: 'Aberta' },
  { id: 'pending',  name: 'Pendente' },
  { id: 'resolved', name: 'Resolvida' },
]
const selectedStatuses    = ref<string[]>(['open'])
const loading            = headerLoading
const overlayVisible     = ref(true)
const overlayMessage     = ref('Verificando Permissões…')

/* ── My-team filter ──────────────────────────── */
const myTeamFilter = headerMyTeamFilter

/* ── Agent summary modal ─────────────────────── */
const agentModalData = ref<{ agent: any; conversations: Conversation[] } | null>(null)

/* ── Contact history modal ───────────────────── */
const historyConv = ref<Conversation | null>(null)

const lastUpdate         = headerLastUpdate
const avPopupRef         = ref<InstanceType<typeof AvatarPopup> | null>(null)

/* ── Aba Agentes — mesmo filtro por permissão (Regra Geral) ─────── */
const agentTeamsMap = computed(() => {
  const map: Record<number, number[]> = {}
  for (const t of allTeamsWithMembers.value)
    for (const mid of t.memberIds) {
      if (!map[mid]) map[mid] = []
      map[mid].push(t.id)
    }
  return map
})

const roleFilteredAgents = computed(() => {
  const uid   = authUser.value?.id
  const scope = resolveRoleScope(uid ?? 0, userTeamIds.value)

  // Administrador / EC - ISBET — travado pelo nome, ignora tudo abaixo
  if (scope.unrestricted) return allAgents.value

  // 1ª/2ª prioridade — Agente vê colegas do(s) próprio(s) time(s); Supervisor vê agentes do(s) Time(s) real(is) que supervisiona
  if (scope.hasSomenteAgente || scope.hasAgenteETime) {
    return allAgents.value.filter(a =>
      a.id === uid || (scope.tids.length > 0 && agentTeamsMap.value[a.id]?.some(tid => scope.tids.includes(tid)))
    )
  }

  // 3ª prioridade — Todas as Atribuições
  if (scope.hasTodos) return allAgents.value

  // Fallback (sem regra geral definida): filtro restritivo (próprio + times)
  return allAgents.value.filter(a =>
    a.id === uid || (scope.tids.length > 0 && agentTeamsMap.value[a.id]?.some(tid => scope.tids.includes(tid)))
  )
})

/* ── Opções de time — construídas da visão já filtrada ── */
const teamOptions = computed(() => {
  const map = new Map<number, string>()
  roleFilteredConversations.value.forEach(c => {
    if (c.team) map.set(c.team.id, c.team.name)
  })
  const list = Array.from(map.entries())
    .map(([id, name]) => ({ id, name }))
    .sort((a, b) => a.name.localeCompare(b.name))

  if (roleFilteredConversations.value.some(c => !c.team)) {
    list.push({ id: -1, name: 'TypeBot' })
  }
  return list
})

// Pré-seleciona todos os times disponíveis para usuários sem visaoTodos
watch(
  [userTeamIds, teamOptions],
  ([_tids, opts], prev) => {
    const uid = authUser.value?.id ?? 0
    const scope = resolveRoleScope(uid, userTeamIds.value)
    const viewAll = scope.unrestricted ||
                    (!scope.hasSomenteAgente && !scope.hasAgenteETime && scope.hasTodos)
    const currIds = (opts as { id: number }[]).map(t => t.id)

    if (!viewAll && !selectedTeams.value.length) {
      selectedTeams.value = currIds
      return
    }

    // "Todos" (ou a pré-seleção acima) grava os ids concretos que existiam na hora —
    // sem isso, um time/bucket novo (ex: "TypeBot" = conversa sem time) que apareça
    // DEPOIS fica de fora do filtro pra sempre, mesmo o usuário "achando" que está
    // vendo tudo. Se a seleção atual já cobria 100% dos ids anteriores, trata como
    // "modo ver tudo" e absorve os novos ids automaticamente.
    const prevOpts = (prev?.[1] as { id: number }[] | undefined) ?? []
    const prevIds  = prevOpts.map(t => t.id)
    const wasShowingAll = prevIds.length > 0 && prevIds.every(id => selectedTeams.value.includes(id))
    if (wasShowingAll) {
      const newIds = currIds.filter(id => !selectedTeams.value.includes(id))
      if (newIds.length) selectedTeams.value = [...selectedTeams.value, ...newIds]
    }
  },
  { immediate: true },
)

const labelOptions = computed(() => {
  const all = [...new Set(roleFilteredConversations.value.flatMap(c => c.labels))].filter(Boolean)
  return all.sort((a, b) => a.localeCompare(b))
})

const fluxoOptions = computed(() => {
  const ids = [...new Set(roleFilteredConversations.value
    .map(c => c.fluxo_id)
    .filter((id): id is number => id !== null)
  )].sort((a, b) => a - b)
  return ids.map(id => ({ id, name: fluxoLabel(id) }))
})

const filteredConversations = computed(() => {
  let result = roleFilteredConversations.value.filter(c => !isFluxoHidden(c.fluxo_id))

  if (selectedTeams.value.length) {
    result = result.filter(c => {
      if (c.team  && selectedTeams.value.includes(c.team.id)) return true
      if (!c.team && selectedTeams.value.includes(-1))        return true
      return false
    })
  }

  if (selectedLabels.value.length) {
    result = result.filter(c =>
      selectedLabels.value.some(label => c.labels.includes(label))
    )
  }

  if (selectedFluxos.value.length) {
    result = result.filter(c =>
      c.fluxo_id !== null && selectedFluxos.value.includes(c.fluxo_id)
    )
  }

  // Lista vazia = sem restrição (mesma convenção dos filtros acima) — inclui
  // até "snoozed" (Adiada), que não tem checkbox próprio no multiselect.
  if (selectedStatuses.value.length) {
    result = result.filter(c => selectedStatuses.value.includes(c.status))
  }

  if (myTeamFilter.value && authUser.value) {
    const uid  = authUser.value.id
    const tids = userTeamIds.value
    result = result.filter(c =>
      c.assignee?.id === uid || (c.team && tids.includes(c.team.id))
    )
  }

  result = result.filter(c => passesFluxoFilter(c.fluxo_id))

  return result
})

watch(filteredConversations, convs => setConvNavList(convs.map((c: any) => c.id)), { immediate: true })

const myCount = computed(() =>
  conversations.value.filter(c => c.assignee?.id === authUser.value?.id).length
)
watch(myCount, v => { headerMyCount.value = v }, { immediate: true })

const myOpenCount = computed(() =>
  conversations.value.filter(c => c.assignee?.id === authUser.value?.id && c.status === 'open').length
)
watch(myOpenCount, v => { headerMyOpenCount.value = v }, { immediate: true })

function isTeamSelected(id: number)  { return selectedTeams.value.includes(id) }
function teamName(id: number)        { return teamOptions.value.find(t => t.id === id)?.name || '' }
function teamConvCount(id: number)   {
  if (id === -1) return roleFilteredConversations.value.filter(c => !c.team).length
  return roleFilteredConversations.value.filter(c => c.team?.id === id).length
}

function toggleTeam(id: number) {
  const idx = selectedTeams.value.indexOf(id)
  if (idx === -1) selectedTeams.value.push(id)
  else selectedTeams.value.splice(idx, 1)
}
function selectAllTeams() { selectedTeams.value = teamOptions.value.map(t => t.id) }
function clearTeams()     { selectedTeams.value = [] }

function isLabelSelected(label: string)  { return selectedLabels.value.includes(label) }
function toggleLabel(label: string) {
  const idx = selectedLabels.value.indexOf(label)
  if (idx === -1) selectedLabels.value.push(label)
  else            selectedLabels.value.splice(idx, 1)
}
function selectAllLabels() { selectedLabels.value = [...labelOptions.value] }
function clearLabels()     { selectedLabels.value = [] }
function labelConvCount(label: string) {
  return roleFilteredConversations.value.filter(c => c.labels.includes(label)).length
}

function isFluxoSelected(id: number)  { return selectedFluxos.value.includes(id) }
function toggleFluxo(id: number) {
  const idx = selectedFluxos.value.indexOf(id)
  if (idx === -1) selectedFluxos.value.push(id)
  else            selectedFluxos.value.splice(idx, 1)
}
function selectAllFluxos() { selectedFluxos.value = fluxoOptions.value.map(f => f.id) }
function clearFluxos()     { selectedFluxos.value = [] }
function fluxoConvCount(id: number) {
  return roleFilteredConversations.value.filter(c => c.fluxo_id === id).length
}


function onDocClick(e: MouseEvent) {
  if (filterDropdownRef.value && !filterDropdownRef.value.contains(e.target as Node)) {
    filterOpen.value = false
  }
  if (labelFilterDropdownRef.value && !labelFilterDropdownRef.value.contains(e.target as Node)) {
    labelFilterOpen.value = false
  }
  if (fluxoFilterDropdownRef.value && !fluxoFilterDropdownRef.value.contains(e.target as Node)) {
    fluxoFilterOpen.value = false
  }
}

watch(teamOptions, (opts) => {
  const valid = opts.map(t => t.id)
  selectedTeams.value = selectedTeams.value.filter(id => valid.includes(id))
})

/* ── KPI ────────────────────────────────────── */
const kpi = computed(() => {
  const c    = filteredConversations.value
  // Conversas abertas com a etiqueta "avaliacao_atendimento" (fluxo interno
  // de avaliação/CSAT do bot, mesmo critério de TabsPanel.vue/useMyConversations.ts)
  // saem do KPI "Abertas" e viram o KPI "Em Avaliação" — não são atendimento
  // real em andamento, só aguardando resposta de CSAT.
  const open = c.filter(x => x.status === 'open' && !x.labels.includes('avaliacao_atendimento')).length
  const emAvaliacao = c.filter(x => x.status === 'open' && x.labels.includes('avaliacao_atendimento')).length
  const resolved = c.filter(x => x.status === 'resolved').length
  const total = c.length
  return {
    total,
    open,
    emAvaliacao,
    unassigned: c.filter(x => !x.assignee && (x.status === 'open' || x.status === 'pending')).length,
    resolved,
    resPct:  total > 0 ? Math.round(resolved / total * 100) : 0,
  }
})

/* ── Avatar popup ───────────────────────────── */
function showPopup(data: PopupData, el: HTMLElement) {
  avPopupRef.value?.show(data, el)
}
function hidePopup() {
  avPopupRef.value?.hide()
}

/* ── Report generation ──────────────────────── */
function generateReport() {
  const convs = filteredConversations.value
  if (!convs.length) { toast('Sem dados para exportar', true); return }

  const filterLabel = selectedTeams.value.length
    ? selectedTeams.value.map(id => teamName(id)).join(', ')
    : null

  const now     = new Date()
  const dateStr = now.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
  const timeStr = now.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })

  const total      = convs.length
  const openN      = convs.filter(c => c.status === 'open').length
  const resolvedN  = convs.filter(c => c.status === 'resolved').length
  const pendingN   = convs.filter(c => c.status === 'pending').length
  const unassigned = convs.filter(c => !c.assignee).length
  const resPct     = total > 0 ? Math.round(resolvedN / total * 100) : 0
  const unread     = convs.reduce((s, c) => s + c.unread_count, 0)

  const teamMap: Record<string, any> = {}
  convs.forEach(c => {
    const k = c.team?.name || 'TypeBot'
    if (!teamMap[k]) teamMap[k] = { total: 0, open: 0, resolved: 0, pending: 0 }
    teamMap[k].total++
    if (c.status === 'open')     teamMap[k].open++
    if (c.status === 'resolved') teamMap[k].resolved++
    if (c.status === 'pending')  teamMap[k].pending++
  })
  const teams = Object.entries(teamMap).sort((a, b) => b[1].total - a[1].total)

  const agMap: Record<number, any> = {}
  convs.forEach(c => {
    if (!c.assignee) return
    const a = c.assignee
    if (!agMap[a.id]) agMap[a.id] = { ...a, total: 0, open: 0, resolved: 0, pending: 0, resolveSecs: [] }
    agMap[a.id].total++
    if (c.status === 'open')     agMap[a.id].open++
    if (c.status === 'pending')  agMap[a.id].pending++
    if (c.status === 'resolved') {
      agMap[a.id].resolved++
      if (c.resolved_at && c.created_at && c.resolved_at > c.created_at)
        agMap[a.id].resolveSecs.push(c.resolved_at - c.created_at)
    }
  })
  const agents = Object.values(agMap).sort((a, b) => b.total - a.total).map(a => ({
    ...a,
    avgResolve: a.resolveSecs.length ? Math.round(a.resolveSecs.reduce((s: number, v: number) => s + v, 0) / a.resolveSecs.length) : 0,
  }))

  function fmtDur(secs: number) {
    if (!secs || secs <= 0) return '—'
    const m = Math.floor(secs / 60), h = Math.floor(m / 60), d = Math.floor(h / 24)
    if (d > 0) return `${d}d ${h % 24}h`
    if (h > 0) return `${h}h ${m % 60 > 0 ? (m % 60) + 'min' : ''}`.trim()
    if (m > 0) return `${m}min`
    return '<1min'
  }

  const html = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
<meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1">
<title>Relatório Wootdash — ISBET ${dateStr}</title>
<link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap" rel="stylesheet">
<style>
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
body{font-family:'Poppins',Arial,sans-serif;background:#F4F5F7;color:#1A1A1A;font-size:13px;-webkit-print-color-adjust:exact;print-color-adjust:exact}
.r-page{max-width:1100px;margin:0 auto;padding:32px 28px 56px}
.r-header{background:linear-gradient(135deg,#BC0C24 0%,#73010F 100%);border-radius:14px;padding:28px 32px;display:flex;align-items:center;justify-content:space-between;margin-bottom:28px;box-shadow:0 6px 24px rgba(115,1,15,.3)}
.r-title{color:#fff;font-size:22px;font-weight:800;line-height:1.2}
.r-subtitle{color:rgba(255,255,255,.6);font-size:11.5px;margin-top:3px}
.r-date{color:rgba(255,255,255,.9);font-size:13px;font-weight:600;text-align:right}
.r-date small{display:block;color:rgba(255,255,255,.45);font-size:10.5px;margin-top:2px;font-weight:400}
.r-kpi-row{display:grid;grid-template-columns:repeat(auto-fit,minmax(160px,1fr));gap:14px;margin-bottom:24px}
.r-kpi{background:#fff;border-radius:12px;border:1px solid #E9EAEC;padding:18px 16px;box-shadow:0 1px 4px rgba(0,0,0,.05)}
.r-kpi-v{font-size:32px;font-weight:800;line-height:1;margin-bottom:4px}
.r-kpi-l{font-size:11px;font-weight:600;color:#6B6B6B;text-transform:uppercase;letter-spacing:.5px}
.r-sec-title{font-size:10.5px;font-weight:700;text-transform:uppercase;letter-spacing:1.6px;color:#6B6B6B;margin-bottom:14px;display:flex;align-items:center;gap:8px}
.r-sec-title::after{content:'';flex:1;height:1px;background:#E5E7EB}
.r-card{background:#fff;border-radius:12px;border:1px solid #E9EAEC;box-shadow:0 1px 4px rgba(0,0,0,.05);overflow:hidden;margin-bottom:20px}
table{width:100%;border-collapse:collapse;font-size:12px}
thead tr{background:#F9FAFB}
th{padding:9px 14px;text-align:left;font-size:10.5px;font-weight:700;text-transform:uppercase;letter-spacing:.7px;color:#6B6B6B;white-space:nowrap;border-bottom:1px solid #E9EAEC}
td{padding:10px 14px;border-bottom:1px solid #F3F4F6;color:#3D3D3D;vertical-align:middle}
tr:last-child td{border-bottom:none}
.r-footer{text-align:center;padding:24px 0 0;color:#9CA3AF;font-size:11px}
@media print{body{background:#fff}.r-page{padding:0}}
</style>
</head>
<body>
<div class="r-page">
  <div class="r-header">
    <div>
      <div class="r-title">Relatório Wootdash</div>
      <div class="r-subtitle">ISBET — ${filterLabel ? `Filtrado por: ${filterLabel}` : 'Todos os times'}</div>
    </div>
    <div class="r-date">${dateStr} ${timeStr}<small>Gerado automaticamente</small></div>
  </div>
  <div class="r-kpi-row">
    <div class="r-kpi"><div class="r-kpi-v" style="color:#BC0C24">${total}</div><div class="r-kpi-l">Total</div></div>
    <div class="r-kpi"><div class="r-kpi-v" style="color:#0369A1">${openN}</div><div class="r-kpi-l">Abertas</div></div>
    <div class="r-kpi"><div class="r-kpi-v" style="color:#1F8C5A">${resolvedN}</div><div class="r-kpi-l">Resolvidas (${resPct}%)</div></div>
    <div class="r-kpi"><div class="r-kpi-v" style="color:#FF6600">${pendingN}</div><div class="r-kpi-l">Pendentes</div></div>
    <div class="r-kpi"><div class="r-kpi-v" style="color:#BC0C24">${unassigned}</div><div class="r-kpi-l">Sem agente</div></div>
    <div class="r-kpi"><div class="r-kpi-v" style="color:#021627">${unread}</div><div class="r-kpi-l">Não lidas</div></div>
  </div>
  <div class="r-sec-title">Por Time</div>
  <div class="r-card">
    <table>
      <thead><tr><th>Time</th><th>Total</th><th>Abertas</th><th>Resolvidas</th><th>Pendentes</th></tr></thead>
      <tbody>${teams.map(([name, d]) => `<tr><td><strong>${name}</strong></td><td>${d.total}</td><td>${d.open}</td><td>${d.resolved}</td><td>${d.pending}</td></tr>`).join('')}</tbody>
    </table>
  </div>
  <div class="r-sec-title">Por Agente</div>
  <div class="r-card">
    <table>
      <thead><tr><th>Agente</th><th>Total</th><th>Abertas</th><th>Resolvidas</th><th>TMR</th></tr></thead>
      <tbody>${agents.map(a => `<tr><td><strong>${a.name}</strong></td><td>${a.total}</td><td>${a.open}</td><td>${a.resolved}</td><td>${a.avgResolve > 0 ? fmtDur(a.avgResolve) : '—'}</td></tr>`).join('')}</tbody>
    </table>
  </div>
  <div class="r-footer"><strong>ISBET</strong> — Wootdash</div>
</div>
</body>
</html>`

  const win = window.open('', '_blank')
  if (win) { win.document.write(html); win.document.close() }
}

onMounted(async () => {
  registerHeaderCallbacks({
    onExport:    generateReport,
    onTestNotif: testNotification,
  })
  document.addEventListener('click', onDocClick)
  // Overlay cobre só a verificação de permissões (rápida, local) — não espera
  // mais o motor (useDashboardEngine.ts) terminar a primeira carga de dados.
  // Fase 3 do plano de carregamento progressivo (docs/planos/PLANO-SKELETON-DASHBOARD.md):
  // KPIs/grade já mostram skeleton próprio enquanto `scopeReady` não vira
  // `true` (ver KpiGrid.vue/ConversationsPanel.vue) — a tela inteira não
  // precisa mais ficar escondida atrás de um overlay de tela cheia esperando
  // isso. Se o motor já rodou antes (ex.: usuário navegou aqui vindo de
  // outra tela), startDashboardEngine() resolve na hora — chamado aqui só de
  // garantia (idempotente, mesma promise que App.vue já dispara no login).
  overlayVisible.value = true
  overlayMessage.value  = 'Verificando permissões…'
  // Fase 1 do plano de carregamento pós-login (PLANO-OTIMIZACAO-CARREGAMENTO-DASHBOARD.md):
  // loadProfiles()/applyDBProfiles() já rodaram em initAuthenticatedSession()
  // (login ao vivo, LoginView.vue) ou main.ts::bootstrap() (sessão restaurada
  // a frio) — os dois caminhos terminam ANTES desta view montar (login espera
  // a promise antes de navegar; bootstrap() só monta a app depois). Refazer
  // aqui era um round-trip n8n redundante, sempre com o mesmo resultado.
  if (authUser.value) syncUserRole(authUser.value.id, authUser.value.role)

  overlayVisible.value = false
  startDashboardEngine()
})

onUnmounted(() => {
  document.removeEventListener('click', onDocClick)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LoadingOverlay, {
      visible: overlayVisible.value,
      message: overlayMessage.value
    }, null, 8, ["visible", "message"]),
    (_unref(dataStale))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[13] || (_cache[13] = _createElementVNode("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }),
            _createElementVNode("line", {
              x1: "12",
              y1: "9",
              x2: "12",
              y2: "13"
            }),
            _createElementVNode("line", {
              x1: "12",
              y1: "17",
              x2: "12.01",
              y2: "17"
            })
          ], -1)),
          _cache[14] || (_cache[14] = _createTextVNode(" Sem conexão com o servidor — exibindo dados de ", -1)),
          _createElementVNode("strong", null, _toDisplayString(_unref(lastUpdate) || '—'), 1),
          _createElementVNode("button", {
            class: "stale-bar-btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(loadData) && _unref(loadData)(...args)))
          }, "Tentar agora")
        ]))
      : _createCommentVNode("", true),
    (teamOptions.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[25] || (_cache[25] = _createElementVNode("span", { class: "filter-label" }, [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" })
              ]),
              _createTextVNode(" Time ")
            ], -1)),
            _createElementVNode("div", {
              class: "flt-dropdown-wrap",
              ref_key: "filterDropdownRef",
              ref: filterDropdownRef
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(["flt-dropdown-btn", { open: filterOpen.value, selected: selectedTeams.value.length > 0 }]),
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (filterOpen.value = !filterOpen.value), ["stop"])),
                disabled: !isAdmin.value && userTeamIds.value.length > 0
              }, [
                _cache[16] || (_cache[16] = _createStaticVNode("<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"9\" cy=\"7\" r=\"4\"></circle><path d=\"M23 21v-2a4 4 0 0 0-3-3.87\"></path><path d=\"M16 3.13a4 4 0 0 1 0 7.75\"></path></svg>", 1)),
                _createElementVNode("span", null, _toDisplayString(selectedTeams.value.length ? `${selectedTeams.value.length} time${selectedTeams.value.length > 1 ? 's' : ''}` : 'Todos os times'), 1),
                (isAdmin.value || !userTeamIds.value.length)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[15] || (_cache[15] = [
                      _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_4),
              _createVNode(_Transition, { name: "dropdown-slide" }, {
                default: _withCtx(() => [
                  (filterOpen.value && (isAdmin.value || !userTeamIds.value.length))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("button", {
                            class: "flt-head-btn",
                            onClick: selectAllTeams
                          }, "Todos"),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(teamOptions.value.length) + " times", 1),
                          _createElementVNode("button", {
                            class: "flt-head-btn danger",
                            onClick: clearTeams
                          }, "Limpar")
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamOptions.value, (t) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: t.id,
                              class: _normalizeClass(["flt-item", { checked: isTeamSelected(t.id), 'flt-item-semtime': t.id === -1 }]),
                              onClick: _withModifiers(($event: any) => (toggleTeam(t.id)), ["prevent"])
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["flt-checkbox", { checked: isTeamSelected(t.id) }])
                              }, [
                                (isTeamSelected(t.id))
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[17] || (_cache[17] = [
                                      _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                    ]))]))
                                  : _createCommentVNode("", true)
                              ], 2),
                              _createElementVNode("span", _hoisted_12, _toDisplayString(t.name), 1),
                              _createElementVNode("span", _hoisted_13, _toDisplayString(teamConvCount(t.id)), 1)
                            ], 10, _hoisted_10))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ], 512),
            _cache[26] || (_cache[26] = _createStaticVNode("<span class=\"filter-sep\"></span><span class=\"filter-label\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z\"></path><line x1=\"7\" y1=\"7\" x2=\"7.01\" y2=\"7\"></line></svg> Etiqueta </span>", 2)),
            _createElementVNode("div", {
              class: "flt-dropdown-wrap",
              ref_key: "labelFilterDropdownRef",
              ref: labelFilterDropdownRef
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(["flt-dropdown-btn", { open: labelFilterOpen.value, selected: selectedLabels.value.length > 0 }]),
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (labelFilterOpen.value = !labelFilterOpen.value), ["stop"])),
                disabled: !labelOptions.value.length
              }, [
                _cache[18] || (_cache[18] = _createElementVNode("svg", {
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("path", { d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" }),
                  _createElementVNode("line", {
                    x1: "7",
                    y1: "7",
                    x2: "7.01",
                    y2: "7"
                  })
                ], -1)),
                _createElementVNode("span", null, _toDisplayString(selectedLabels.value.length ? `${selectedLabels.value.length} etiqueta${selectedLabels.value.length > 1 ? 's' : ''}` : 'Todas as etiquetas'), 1),
                _cache[19] || (_cache[19] = _createElementVNode("svg", {
                  class: "flt-chevron",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
                ], -1))
              ], 10, _hoisted_14),
              _createVNode(_Transition, { name: "dropdown-slide" }, {
                default: _withCtx(() => [
                  (labelFilterOpen.value && labelOptions.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("button", {
                            class: "flt-head-btn",
                            onClick: selectAllLabels
                          }, "Todos"),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(labelOptions.value.length) + " etiqueta" + _toDisplayString(labelOptions.value.length !== 1 ? 's' : ''), 1),
                          _createElementVNode("button", {
                            class: "flt-head-btn danger",
                            onClick: clearLabels
                          }, "Limpar")
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labelOptions.value, (label) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: label,
                              class: _normalizeClass(["flt-item", { checked: isLabelSelected(label) }]),
                              onClick: _withModifiers(($event: any) => (toggleLabel(label)), ["prevent"])
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["flt-checkbox", { checked: isLabelSelected(label) }])
                              }, [
                                (isLabelSelected(label))
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_20, [...(_cache[20] || (_cache[20] = [
                                      _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                    ]))]))
                                  : _createCommentVNode("", true)
                              ], 2),
                              _createElementVNode("span", _hoisted_21, _toDisplayString(label.replace(/_/g, ' ')), 1),
                              _createElementVNode("span", _hoisted_22, _toDisplayString(labelConvCount(label)), 1)
                            ], 10, _hoisted_19))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ], 512),
            _cache[27] || (_cache[27] = _createElementVNode("span", { class: "filter-sep" }, null, -1)),
            _cache[28] || (_cache[28] = _createElementVNode("span", { class: "filter-label" }, [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("polyline", { points: "22 12 18 12 15 21 9 3 6 12 2 12" })
              ]),
              _createTextVNode(" Fluxo ")
            ], -1)),
            _createElementVNode("div", {
              class: "flt-dropdown-wrap",
              ref_key: "fluxoFilterDropdownRef",
              ref: fluxoFilterDropdownRef
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(["flt-dropdown-btn", { open: fluxoFilterOpen.value, selected: selectedFluxos.value.length > 0 }]),
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (fluxoFilterOpen.value = !fluxoFilterOpen.value), ["stop"])),
                disabled: !fluxoOptions.value.length
              }, [
                _cache[21] || (_cache[21] = _createElementVNode("svg", {
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("polyline", { points: "22 12 18 12 15 21 9 3 6 12 2 12" })
                ], -1)),
                _createElementVNode("span", null, _toDisplayString(selectedFluxos.value.length ? `${selectedFluxos.value.length} fluxo${selectedFluxos.value.length > 1 ? 's' : ''}` : 'Todos os fluxos'), 1),
                _cache[22] || (_cache[22] = _createElementVNode("svg", {
                  class: "flt-chevron",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
                ], -1))
              ], 10, _hoisted_23),
              _createVNode(_Transition, { name: "dropdown-slide" }, {
                default: _withCtx(() => [
                  (fluxoFilterOpen.value && fluxoOptions.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("button", {
                            class: "flt-head-btn",
                            onClick: selectAllFluxos
                          }, "Todos"),
                          _createElementVNode("span", _hoisted_26, _toDisplayString(fluxoOptions.value.length) + " fluxo" + _toDisplayString(fluxoOptions.value.length !== 1 ? 's' : ''), 1),
                          _createElementVNode("button", {
                            class: "flt-head-btn danger",
                            onClick: clearFluxos
                          }, "Limpar")
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fluxoOptions.value, (f) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: f.id,
                              class: _normalizeClass(["flt-item", { checked: isFluxoSelected(f.id) }]),
                              onClick: _withModifiers(($event: any) => (toggleFluxo(f.id)), ["prevent"])
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["flt-checkbox", { checked: isFluxoSelected(f.id) }])
                              }, [
                                (isFluxoSelected(f.id))
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_29, [...(_cache[23] || (_cache[23] = [
                                      _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                    ]))]))
                                  : _createCommentVNode("", true)
                              ], 2),
                              _createElementVNode("span", _hoisted_30, _toDisplayString(f.name), 1),
                              _createElementVNode("span", _hoisted_31, _toDisplayString(fluxoConvCount(f.id)), 1)
                            ], 10, _hoisted_28))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ], 512),
            _cache[29] || (_cache[29] = _createStaticVNode("<span class=\"filter-sep\"></span><span class=\"filter-label\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polyline points=\"12 6 12 12 16 14\"></polyline></svg> Status </span>", 2)),
            _createVNode(MultiSelectFilter, {
              options: STATUS_FILTER_OPTIONS,
              "model-value": selectedStatuses.value,
              placeholder: "Todos os status",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (selectedStatuses.value = $event.map(String)))
            }, null, 8, ["model-value"]),
            _cache[30] || (_cache[30] = _createStaticVNode("<span class=\"filter-sep\"></span><span class=\"filter-label\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"10\"></circle><polyline points=\"12 6 12 12 16 14\"></polyline></svg> Tolerância </span>", 2)),
            _createElementVNode("div", _hoisted_32, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "tol-input",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(toleranceMinutes) ? (toleranceMinutes).value = $event : null)),
                min: "1",
                max: "240",
                onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(clampTolerance) && _unref(clampTolerance)(...args)))
              }, null, 544), [
                [
                  _vModelText,
                  _unref(toleranceMinutes),
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "tol-unit" }, "min", -1))
            ])
          ]),
          _createVNode(_Transition, { name: "fade-filter" }, {
            default: _withCtx(() => [
              (selectedTeams.value.length || selectedLabels.value.length || selectedFluxos.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_TransitionGroup, {
                        name: "chip-anim",
                        tag: "div",
                        class: "flt-chips"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTeams.value, (id) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: 't' + id,
                              class: "flt-chip"
                            }, [
                              _createTextVNode(_toDisplayString(teamName(id)) + " ", 1),
                              (isAdmin.value || !userTeamIds.value.length)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "flt-chip-x",
                                    onClick: ($event: any) => (toggleTeam(id))
                                  }, [...(_cache[31] || (_cache[31] = [
                                    _createElementVNode("svg", {
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "3",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }, [
                                      _createElementVNode("line", {
                                        x1: "18",
                                        y1: "6",
                                        x2: "6",
                                        y2: "18"
                                      }),
                                      _createElementVNode("line", {
                                        x1: "6",
                                        y1: "6",
                                        x2: "18",
                                        y2: "18"
                                      })
                                    ], -1)
                                  ]))], 8, _hoisted_35))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_TransitionGroup, {
                        name: "chip-anim",
                        tag: "div",
                        class: "flt-chips"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLabels.value, (label) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: 'l' + label,
                              class: "flt-chip flt-chip-label"
                            }, [
                              _createTextVNode(_toDisplayString(label.replace(/_/g, ' ')) + " ", 1),
                              _createElementVNode("button", {
                                class: "flt-chip-x",
                                onClick: ($event: any) => (toggleLabel(label))
                              }, [...(_cache[32] || (_cache[32] = [
                                _createElementVNode("svg", {
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "3",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("line", {
                                    x1: "18",
                                    y1: "6",
                                    x2: "6",
                                    y2: "18"
                                  }),
                                  _createElementVNode("line", {
                                    x1: "6",
                                    y1: "6",
                                    x2: "18",
                                    y2: "18"
                                  })
                                ], -1)
                              ]))], 8, _hoisted_36)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_TransitionGroup, {
                        name: "chip-anim",
                        tag: "div",
                        class: "flt-chips"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFluxos.value, (id) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: 'f' + id,
                              class: "flt-chip flt-chip-fluxo"
                            }, [
                              _createTextVNode(_toDisplayString(_unref(fluxoLabel)(id)) + " ", 1),
                              _createElementVNode("button", {
                                class: "flt-chip-x",
                                onClick: ($event: any) => (toggleFluxo(id))
                              }, [...(_cache[33] || (_cache[33] = [
                                _createElementVNode("svg", {
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "3",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("line", {
                                    x1: "18",
                                    y1: "6",
                                    x2: "6",
                                    y2: "18"
                                  }),
                                  _createElementVNode("line", {
                                    x1: "6",
                                    y1: "6",
                                    x2: "18",
                                    y2: "18"
                                  })
                                ], -1)
                              ]))], 8, _hoisted_37)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      ((selectedTeams.value.length && (isAdmin.value || !userTeamIds.value.length)) || selectedLabels.value.length || selectedFluxos.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("span", _hoisted_39, [
                              _cache[34] || (_cache[34] = _createElementVNode("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                              ], -1)),
                              _createTextVNode(" " + _toDisplayString(filteredConversations.value.length) + " conversa" + _toDisplayString(filteredConversations.value.length !== 1 ? 's' : ''), 1)
                            ]),
                            _createElementVNode("button", {
                              class: "filter-clear",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => {clearTeams(); clearLabels(); clearFluxos()})
                            }, [...(_cache[35] || (_cache[35] = [
                              _createElementVNode("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("line", {
                                  x1: "18",
                                  y1: "6",
                                  x2: "6",
                                  y2: "18"
                                }),
                                _createElementVNode("line", {
                                  x1: "6",
                                  y1: "6",
                                  x2: "18",
                                  y2: "18"
                                })
                              ], -1),
                              _createTextVNode(" Limpar tudo ", -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("main", null, [
      (_unref(can)('dashboard.viewKpis'))
        ? (_openBlock(), _createBlock(KpiGrid, {
            key: 0,
            total: kpi.value.total,
            open: kpi.value.open,
            "em-avaliacao": kpi.value.emAvaliacao,
            unassigned: kpi.value.unassigned,
            resolved: kpi.value.resolved,
            "res-pct": kpi.value.resPct,
            periodo: _unref(visaoGeralPeriodo),
            loading: _unref(loading),
            "scope-ready": _unref(scopeReady),
            "month-pending-count": _unref(monthOnlyCount),
            "onUpdate:periodo": _unref(setVisaoGeralPeriodo)
          }, null, 8, ["total", "open", "em-avaliacao", "unassigned", "resolved", "res-pct", "periodo", "loading", "scope-ready", "month-pending-count", "onUpdate:periodo"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_40, [
        _createVNode(TabsPanel, {
          conversations: filteredConversations.value,
          "all-agents": roleFilteredAgents.value,
          "agent-teams-map": agentTeamsMap.value,
          "tolerance-minutes": _unref(toleranceMinutes),
          "scope-ready": _unref(scopeReady),
          onShowPopup: showPopup,
          onHidePopup: hidePopup
        }, null, 8, ["conversations", "all-agents", "agent-teams-map", "tolerance-minutes", "scope-ready"]),
        _createVNode(SidePanel, {
          conversations: filteredConversations.value,
          "agent-teams-map": agentTeamsMap.value,
          "scope-ready": _unref(scopeReady),
          onShowPopup: showPopup,
          onHidePopup: hidePopup,
          onOpenAgentSummary: _cache[8] || (_cache[8] = (agent, convs) => agentModalData.value = { agent: { ...agent, teamIds: agentTeamsMap.value[agent.id] ?? [] }, conversations: convs })
        }, null, 8, ["conversations", "agent-teams-map", "scope-ready"])
      ]),
      _createVNode(ConversationsPanel, {
        conversations: filteredConversations.value,
        loading: _unref(loading),
        "scope-ready": _unref(scopeReady),
        "changed-ids": _unref(changedIds),
        onShowPopup: showPopup,
        onHidePopup: hidePopup,
        onOpenChat: _unref(openFloatChat),
        onOpenHistory: _cache[9] || (_cache[9] = (conv) => historyConv.value = conv)
      }, null, 8, ["conversations", "loading", "scope-ready", "changed-ids", "onOpenChat"]),
      (agentModalData.value)
        ? (_openBlock(), _createBlock(AgentSummaryModal, {
            key: 1,
            data: { ...agentModalData.value.agent, conversations: agentModalData.value.conversations },
            onClose: _cache[10] || (_cache[10] = ($event: any) => (agentModalData.value = null)),
            onOpenChat: _unref(openFloatChat)
          }, null, 8, ["data", "onOpenChat"]))
        : _createCommentVNode("", true),
      (historyConv.value)
        ? (_openBlock(), _createBlock(ContactHistoryModal, {
            key: 2,
            contact: historyConv.value.contact,
            "account-id": CHATWOOT_ACCOUNT_ID,
            "access-token": authUser.value?.access_token ?? '',
            onClose: _cache[11] || (_cache[11] = ($event: any) => (historyConv.value = null)),
            onOpenChat: _cache[12] || (_cache[12] = (c) => { historyConv.value = null; _unref(openFloatChat)(c) })
          }, null, 8, ["contact", "access-token"]))
        : _createCommentVNode("", true)
    ]),
    _cache[41] || (_cache[41] = _createElementVNode("footer", null, [
      _createElementVNode("p", null, [
        _createTextVNode("Wootdash  ·  "),
        _createElementVNode("strong", null, "ISBET"),
        _createTextVNode("  ·  "),
        _createElementVNode("span", null, "Tecnologia ISBET")
      ])
    ], -1)),
    _createElementVNode("div", {
      id: "toast",
      class: _normalizeClass({ show: _unref(toastVisible), err: _unref(toastError) })
    }, _toDisplayString(_unref(toastMessage)), 3),
    _createVNode(AvatarPopup, {
      ref_key: "avPopupRef",
      ref: avPopupRef
    }, null, 512),
    _createVNode(_TransitionGroup, {
      name: "notif-slide",
      tag: "div",
      class: "notif-stack"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeNotifications), (n) => {
          return (_openBlock(), _createElementBlock("div", {
            key: n.uid,
            class: "notif-card"
          }, [
            _cache[40] || (_cache[40] = _createElementVNode("div", { class: "notif-card-icon" }, [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("circle", {
                  cx: "12",
                  cy: "12",
                  r: "10"
                }),
                _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("strong", null, _toDisplayString(n.contactName), 1),
                _cache[36] || (_cache[36] = _createTextVNode(" aguarda resposta ", -1))
              ]),
              _createElementVNode("div", _hoisted_43, _toDisplayString(n.waitLabel) + " esperando", 1),
              _createElementVNode("div", _hoisted_44, [
                (n.team)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                      _cache[37] || (_cache[37] = _createElementVNode("svg", {
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
                        _createElementVNode("circle", {
                          cx: "9",
                          cy: "7",
                          r: "4"
                        }),
                        _createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87" }),
                        _createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(n.team), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: _normalizeClass(["notif-meta-tag", { 'notif-muted': !n.agent }])
                }, [
                  _cache[38] || (_cache[38] = _createElementVNode("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "7",
                      r: "4"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(n.agent || 'Sem agente'), 1)
                ], 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("button", {
                class: "notif-btn-go",
                onClick: ($event: any) => {_unref(requestOpenChat)(n.convId); _unref(dismissNotif)(n.uid)}
              }, "Ver Conversa", 8, _hoisted_47),
              _createElementVNode("button", {
                class: "notif-btn-close",
                onClick: ($event: any) => (_unref(dismissNotif)(n.uid)),
                title: "Fechar"
              }, [...(_cache[39] || (_cache[39] = [
                _createElementVNode("svg", {
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("line", {
                    x1: "18",
                    y1: "6",
                    x2: "6",
                    y2: "18"
                  }),
                  _createElementVNode("line", {
                    x1: "6",
                    y1: "6",
                    x2: "18",
                    y2: "18"
                  })
                ], -1)
              ]))], 8, _hoisted_48)
            ])
          ]))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}
}

})